import { hasSelectedFacets, getSort } from "./modules/search";
import isFacetedNavPage from "./modules/category/selectors/isFacetedNavPage";

export const shouldRenderPagination = state =>
  (isFacetedNavPage(state) || !hasSelectedFacets(state)) && !getSort(state);
